import React from 'react';
import routes from '../routing/routesApp';
import Navbar from '../components/partials/navbar/Navbar';
import Footer from '../components/partials/footer/Footer';
import App from '../App';

const AppEp = () => (
    <App
        routes={routes}
        routesWrapper={({children}) => <>
            <Navbar />
            <div className="navbar-placeholder">
                {children}
            </div>
            <Footer />
        </>}
    />
);

export default AppEp;
